import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaterialService {

  constructor(private http: HttpClient) { }

  postMaterial(formData){
    return this.http.post(environment.apiBaseURI + '/Material', formData)
  }

  putMaterial(formData){
    return this.http.put(environment.apiBaseURI + '/Material/' + formData.id, formData)
  }

  getMaterialList(param: any){
    return this.http.post(environment.apiBaseURI + '/Material/GetMaterialDetails', param);
  }
  getMaterials(){
    return this.http.get(environment.apiBaseURI + '/Material');
  }
  deleteMaterial(id){
    return this.http.delete(environment.apiBaseURI + '/Material/' + id);
  }
}
